import request from '../../../helpers/request';

import {
  ASYNC_TEAM_FETCH_STANDINGS_REQUEST,
  ASYNC_TEAM_FETCH_STANDINGS_SUCCESS,
  ASYNC_TEAM_FETCH_STANDINGS_ERROR
} from './types';

function asyncTeamFetchStandingsRequest() {
  return {
    type: ASYNC_TEAM_FETCH_STANDINGS_REQUEST
  };
}

function asyncTeamFetchStandingsSuccess(data) {
  return {
    type: ASYNC_TEAM_FETCH_STANDINGS_SUCCESS,
    data
  };
}

function asyncTeamFetchStandingsError(error) {
  return {
    type: ASYNC_TEAM_FETCH_STANDINGS_ERROR,
    error
  };
}

export function fetchStandings(id, clientId, productId) {
  return (dispatch) => {
    dispatch(asyncTeamFetchStandingsRequest());
    request(`/v2/standings/${id}/null/${clientId}/${productId}`)
      .then((res) => dispatch(asyncTeamFetchStandingsSuccess(res.data)))
      .catch((error) => dispatch(asyncTeamFetchStandingsError(error)));
  };
}



// WEBPACK FOOTER //
// ./src/screens/standingsScreen/state/standingsActions.js